import { useIsAdmin } from '@jira/polaris__component-permissions-store/src/useIsAdmin.tsx';
import { useCanManageViews } from '@jira/polaris__component-permissions-store/src/useCanManageViews.tsx';
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import {
	VIEW_KIND_BOARD,
	VIEW_KIND_TABLE,
	VIEW_KIND_TIMELINE,
} from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';

const ALLOWED_VIEW_KINDS: readonly ViewKind[] = [
	VIEW_KIND_TABLE,
	VIEW_KIND_BOARD,
	VIEW_KIND_TIMELINE,
];

type UseCanSaveAsGlobalViewOptions = {
	isGlobalView: boolean;
	viewKind: ViewKind | undefined;
};

export const useCanSaveAsGlobalView = ({
	isGlobalView,
	viewKind,
}: UseCanSaveAsGlobalViewOptions): boolean => {
	const isAdmin = useIsAdmin();
	const canManageViews = useCanManageViews();

	if (!viewKind) {
		return false;
	}

	return !isGlobalView && ALLOWED_VIEW_KINDS.includes(viewKind) && canManageViews && isAdmin;
};
